module.exports = __webpack_public_path__ + "static/media/2.1328c801.png";